export function getGenerationFailureMessage({ fullAccess, failedDayLabel }) {
  if (!fullAccess) {
    return "We couldn't finish generating this itinerary preview. Please return to your interview and create a new preview.";
  }

  return `We couldn't finish generating ${failedDayLabel || 'the full itinerary'}. Any completed days are safe.`;
}
